import getCountryFromUrl from "utils/getCountryFromUrl";

export const generateSaleNavElementKey = o => {
  const countryCode = getCountryFromUrl();
  const saleNavigationElementKey = `SaleNavigationElement:${o.__typename}:${o.id}:${o.displayName}:${o.siteId}:${countryCode}:${o?.filter}`;
  return saleNavigationElementKey;
};
